<template>
  <div class="wrap">
    <svg viewBox="0 0 108 100" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'wrap__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M57 94h10c1.7 0 3 1.3 3 3s-1.3 3-3 3H41c-1.7 0-3-1.3-3-3s1.3-3 3-3h10v-8h6zM8 6c-1.1 0-2 .9-2 2v70c0 1.1.9 2 2 2h92c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0-6h92c4.4 0 8 3.6 8 8v70c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8V8c0-4.4 3.6-8 8-8z"/><path d="M52 63h10c1.1 0 2 .9 2 2s-.9 2-2 2H52c-1.1 0-2-.9-2-2s.9-2 2-2zM71.3 27.3l11.3 4.1c1 .4 1.6 1.5 1.2 2.6-.4 1-1.5 1.6-2.6 1.2l-11.3-4.1c-1-.4-1.6-1.5-1.2-2.6s1.6-1.5 2.6-1.2zM38.2 27.3c1-.4 2.2.2 2.6 1.2s-.2 2.2-1.2 2.6l-11.3 4.1c-1 .4-2.2-.2-2.6-1.2s.2-2.2 1.2-2.6z"/><circle cx="75" cy="46" r="6"/><circle cx="35" cy="46" r="6"/></svg>
    <h1>Page Not Found</h1>
    <p>Sorry, but the page you were trying to view does not exist.</p>
  </div>
</template>

<script>

export default {
  name: 'NotFound',
};
</script>

<style scoped lang='stylus'>

m-270()
  @media all and (max-width: 270px)
    {block}

.wrap
  position absolute
  top 20%
  left 50%
  margin 0 0 0 -150px
  width 300px
  color #888
  font-family sans-serif
  text-align center
  &__icon
    display block
    width 80%
    margin 30px auto

h1
  color #555
  font-size 2em
  font-weight 400

p
  font-size 1.5em
  line-height 1.2

</style>
